
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram",
      function () {
        return require("private-next-pages/instagram/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram"])
      });
    }
  